import PropTypes from 'prop-types';
import { Grid, Button } from '@mui/material';
import Iconify from '../../../../reusable-components/iconify';
import { useScopeCheck } from '../../../../reusable-components/scopes';
import AddButton from '../../../../reusable-components/basic-buttons/AddButton';
import FacilityAccountConfirmDialog from './FacilityAccountConfirmDialog';

FacilityAccountActions.propTypes = {
  setOpenForm: PropTypes.func,
  setBulkUpdateAccounts: PropTypes.func,
  onBulkSave: PropTypes.func,
  onCancel: PropTypes.func,
  isSavingBulk: PropTypes.bool,
  bulkUpdateAccounts: PropTypes.bool,
  saveType: PropTypes.string,
  hasSelection: PropTypes.bool,
};

export default function FacilityAccountActions({
  onBulkSave,
  onCancel,
  isSavingBulk,
  saveType,
  bulkUpdateAccounts,
  setBulkUpdateAccounts,
  setOpenForm,
  hasSelection,
}) {
  const canEditFacilityAccounts = useScopeCheck(['Edit-Facility-Accounts'], true);

  const getIsDisabled = (type) => !hasSelection || (isSavingBulk && saveType !== type);

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item>
        {!bulkUpdateAccounts ? (
          <>
            {canEditFacilityAccounts && <AddButton onClick={() => setOpenForm(true)}>Add Account</AddButton>}
            <Button
              variant="outlined"
              color="secondary"
              sx={{ mr: 1 }}
              size="small"
              onClick={() => window.open(`/Api/FacilityAccount/DownloadFacilityAccountsExcel`, '_blank')}
              startIcon={<Iconify icon="file-icons:microsoft-excel" />}
            >
              Download
            </Button>
            {canEditFacilityAccounts && (
              <Button
                variant="outlined"
                color="secondary"
                sx={{ mr: 1 }}
                size="small"
                onClick={() => setBulkUpdateAccounts(true)}
              >
                Edit Accounts
              </Button>
            )}
          </>
        ) : (
          <>
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Disable Invoices')}
              title="Disable Invoices"
              content={`Are you sure you want to disable invoices?`}
              actionButtonText="Disable Invoices"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Disable Invoices')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Enable Invoices')}
              title="Enable Invoices"
              content={`Are you sure you want to enable invoices?`}
              actionButtonText="Enable Invoices"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Enable Invoices')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Update Orders Only')}
              title="Update Orders Only"
              content={`Are you sure you want to set invoices to update orders only?`}
              actionButtonText="Update Orders Only"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Update Orders Only')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Disable Orders')}
              title="Disable Orders"
              content={`Are you sure you want to disable orders?`}
              actionButtonText="Disable Orders"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Disable Orders')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Enable Orders')}
              title="Enable Orders"
              content={`Are you sure you want to enable orders?`}
              actionButtonText="Enable Orders"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Enable Orders')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('On Hold')}
              title="On Hold"
              content={`Are you sure you want to put orders on hold?`}
              actionButtonText="On Hold"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('On Hold')}
            />
            <FacilityAccountConfirmDialog
              sx={{ mr: 1 }}
              disabled={getIsDisabled('Delete Vendor Accounts')}
              title="Delete Vendor Accounts"
              content={`Are you sure you want to delete vendor accounts?`}
              actionButtonText="Delete Vendor Accounts"
              buttonVariant="outlined"
              color="secondary"
              action={() => onBulkSave('Delete Vendor Accounts')}
            />
            <Button sx={{ mr: 1 }} onClick={onCancel} variant="outlined" color="error" size="small">
              Cancel
            </Button>
          </>
        )}
      </Grid>
    </Grid>
  );
}
